import { FC, SVGAttributes } from "react";

const StyleIcon: FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29 18.5C29 18.8889 28.8034 19.3656 28.2193 19.9081C27.6338 20.4519 26.732 20.9876 25.5338 21.4583C23.1436 22.3974 19.7732 23 16 23C12.2268 23 8.85645 22.3974 6.46616 21.4583C5.26798 20.9876 4.36618 20.4519 3.78074 19.9081C3.19663 19.3656 3 18.8889 3 18.5C3 18.1111 3.19663 17.6344 3.78074 17.0919C4.36618 16.5481 5.26798 16.0124 6.46616 15.5417C8.85645 14.6026 12.2268 14 16 14C19.7732 14 23.1436 14.6026 25.5338 15.5417C26.732 16.0124 27.6338 16.5481 28.2193 17.0919C28.8034 17.6344 29 18.1111 29 18.5Z"
      fill="white"
      stroke="black"
      strokeWidth="2"
    />
    <path
      d="M11.5076 9.09262C11.6371 8.57477 12.1505 8.24989 12.6739 8.35458L14.235 8.66679C15.4001 8.89983 16.5999 8.89983 17.765 8.66679L19.3261 8.35458C19.8495 8.24989 20.3629 8.57477 20.4924 9.09262L22.6316 17.6494C22.7352 18.0639 22.5114 18.4902 22.1113 18.6403C18.1711 20.1178 13.8289 20.1178 9.8887 18.6403C9.48864 18.4902 9.26479 18.0639 9.36842 17.6494L11.5076 9.09262Z"
      fill="white"
      stroke="black"
      strokeWidth="2"
    />
    <path
      d="M10 16V16C13.8947 17.2982 18.1053 17.2982 22 16V16"
      stroke="black"
    />
  </svg>
);

export { StyleIcon };
